import { AHText, Box, AHIcon } from "arkh";
import React from "react";
import { graphql, useFragment } from "react-relay";
import { LinkedProducts_products$key } from "./__generated__/LinkedProducts_products.graphql";

export function LinkedProducts(props: {
  products: LinkedProducts_products$key;
}) {
  const products = useFragment(
    graphql`
      fragment LinkedProducts_products on StoreProduct @relay(plural: true) {
        id
        name
        partNumber
        imageUrl
      }
    `,
    props.products
  );

  if (products.length === 0) {
    return null;
  }

  return (
    <Box
      spaceHorizontal="medium"
      spaceTop="medium"
      spaceBottom="medium"
      style={{
        flexDirection: "row",
        flexWrap: "wrap",
        gap: 12,
      }}
    >
      {products.map((product) => (
        <Box
          key={product.id}
          color="surface"
          borderColor="border-primary"
          cornerRadius="medium"
          spaceHorizontal="small"
          spaceVertical="small"
          style={{
            borderWidth: 1,
            flexDirection: "row",
            alignItems: "center",
            minWidth: 200,
          }}
        >
          <AHIcon type="product" color="text-secondary" size="medium" />
          <Box style={{ flex: 1 }} spaceLeft="small">
            <AHText type="body" color="text-primary" numberOfLines={1}>
              {product.name}
            </AHText>
            {product.partNumber ? (
              <AHText type="detail" color="text-secondary">
                {product.partNumber}
              </AHText>
            ) : null}
          </Box>
          {product.imageUrl ? (
            <Box spaceLeft="small">
              <img
                src={product.imageUrl}
                style={{
                  width: 40,
                  height: 40,
                  objectFit: "cover",
                  borderRadius: 8,
                }}
              />
            </Box>
          ) : null}
        </Box>
      ))}
    </Box>
  );
}
